import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the Web Push service worker as soon as the app boots. Failure here
// is non-fatal — push is opt-in and degraded gracefully via getPushSupport().
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
  });

  // Handle deep-link messages dispatched by the SW notificationclick handler.
  navigator.serviceWorker.addEventListener?.("message", (event) => {
    if (event.data?.type === "navigate" && event.data?.url) {
      window.location.assign(event.data.url);
    }
  });
}
